const USER_ADMIN = 'user_0';

export {
  USER_ADMIN,
};
